import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const groupService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    GROUP: 'groups',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.GROUP}`, request);
}

export function store (data) {
    const formData = new FormData();
    formData.append(`name`, data.name);
    if (data.description) formData.append(`description`, data.description);
    if (data.colorCode) formData.append('color_code', data.colorCode);
    if (data.websiteUrl) formData.append('website_url', data.websiteUrl);
    if (data.image instanceof File) formData.append('image', data.image);

    return apiHelper(API_URL).post(`/${MODULE.GROUP}`, formData);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.GROUP}/${uuid}`);
}

export function update (data) {
    const formData = new FormData();
    formData.append(`_method`, 'PUT');
    formData.append(`name`, data.name);
    
    if (data.description) formData.append(`description`, data.description);
    if (data.colorCode) formData.append('color_code', data.colorCode);
    if (data.websiteUrl) formData.append('website_url', data.websiteUrl);
    if (data.image instanceof File) formData.append('image', data.image);

    return apiHelper(API_URL).post(`/${MODULE.GROUP}/${data.uuid}`, formData);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.GROUP}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.GROUP}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.GROUP}/${data.uuid}`);
}
